var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFirstContent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 129,
    height: 305,
    viewBox: "0 0 129 305",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_133",
    "data-name": "Rectangle 133",
    width: 129,
    height: 305,
    transform: "translate(299 1)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.35
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_128",
    "data-name": "Rectangle 128",
    width: 106.805,
    height: 246.361,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_124",
    "data-name": "Rectangle 124",
    width: 97.535,
    height: 154.183,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_125",
    "data-name": "Rectangle 125",
    width: 106.805,
    height: 5.516,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_126",
    "data-name": "Rectangle 126",
    width: 34.616,
    height: 42.307,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_23",
    "data-name": "Mask Group 23",
    transform: "translate(-299 -1)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_523",
    "data-name": "Group 523"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_512",
    "data-name": "Group 512"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_310",
    "data-name": "Group 310",
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 272.615, 50.142)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_309",
    "data-name": "Group 309",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_122",
    "data-name": "Rectangle 122",
    width: 6.585,
    height: 238.967,
    transform: "translate(50.312 0)",
    fill: "#39b54a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    "data-name": "Group 308",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_307",
    "data-name": "Group 307",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_765",
    "data-name": "Path 765",
    d: "M111.654,265.96,93.462,417.869a2.574,2.574,0,0,1-2.555,2.275H34.865a2.574,2.574,0,0,1-2.555-2.275L14.118,265.96Z",
    transform: "translate(-9.225 -173.783)",
    fill: "#9b725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_766",
    "data-name": "Path 766",
    d: "M20.252,185.833a11.708,11.708,0,0,1,2.5-8.785c1.233-1.542,2.963-2.455,4.235-3.943,1.5-1.757,1.388-4.4,2.854-6.086,1.975-2.275,4.936-4.119,7.42-5.668,1.4-.873,3.179-1.509,4.468-2.7,1.479-1.37,1.513-3.277,2.678-4.846,2.5-3.366,7.071-4.45,10.533-6.147a11.946,11.946,0,0,0,4.09-2.908,2.74,2.74,0,0,1,3.37-1.011,46.821,46.821,0,0,1,7.255,4.5,10.732,10.732,0,0,0,2.572,1.53,9.574,9.574,0,0,0,2.75.376c3.452.154,7.5.992,8.969,4.411A3.7,3.7,0,0,0,84.9,156.2a2.776,2.776,0,0,0,1.948.19,7.42,7.42,0,0,1,6.671,3.2,5.189,5.189,0,0,0,1.265,1.51,3.967,3.967,0,0,0,1.441.441c3.838.731,5.4,3.325,7.456,6.947,1.4,2.47,4.393,3.453,6.2,5.489a12.946,12.946,0,0,1,2.273,11.8Z",
    transform: "translate(-13.177 -93.765)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_767",
    "data-name": "Path 767",
    d: "M109.615,155.589a1.028,1.028,0,0,1,1.342.159,8.934,8.934,0,0,0,2.657,2.048,9.266,9.266,0,0,0,3.584,1,.731.731,0,0,1,.02,1.458,9.11,9.11,0,0,1-4.428-.7,9.387,9.387,0,0,1-3.4-2.452,1.031,1.031,0,0,1,.221-1.52",
    transform: "translate(-71.322 -101.548)",
    fill: "#9b725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_768",
    "data-name": "Path 768",
    d: "M111.785,159.538a10.64,10.64,0,0,1-2.012,2.56,23.071,23.071,0,0,1-3.906,3.325,24.471,24.471,0,0,1-9.059,3.644,26.854,26.854,0,0,1-4.637.464,43.9,43.9,0,0,1-4.681-.07c-1.564-.134-3.12-.276-4.712-.573a15.711,15.711,0,0,1-3.99-1.26,1,1,0,0,1-.41-1.188.748.748,0,0,1,.906-.554,32.92,32.92,0,0,0,5.761,1.261,38.663,38.663,0,0,0,6.158-.276,59.447,59.447,0,0,0,11.033-1.479c2.907-.747,5.5-1.76,6.86-4.973a7.934,7.934,0,0,1,.76-1.606,1.431,1.431,0,0,1,1.443-.672c.745.206.769.761.487,1.4",
    transform: "translate(-51.178 -103.31)",
    fill: "#9b725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_769",
    "data-name": "Path 769",
    d: "M109.686,217.154a28.9,28.9,0,0,1-2.921,3.072,7.653,7.653,0,0,1-2.334,1.2,13.213,13.213,0,0,1-5.354.4A51.667,51.667,0,0,1,93.5,220.7a25.736,25.736,0,0,0-5.928-.882,28.781,28.781,0,0,0-6.064.765c-1.957.429-3.827.952-5.582,1.44s-3.507.9-5.329,1.447a37.714,37.714,0,0,1-5.616,1.323,29.32,29.32,0,0,1-5.718.242,21.447,21.447,0,0,1-5.476-1.076,52.666,52.666,0,0,0-5.588-1.992c-3.975-1.017-8-.854-11.776-.687a15.283,15.283,0,0,1-4.275-.106,4.378,4.378,0,0,1-.814-.27,1.162,1.162,0,0,0-1.5.407,3.138,3.138,0,0,0-.2.376c-.269.59-1.1,1.323-.612,1.707a5.4,5.4,0,0,0,1.31.766,9.057,9.057,0,0,0,3.249.636c1.03.055,1.986-.013,2.967-.041,3.885-.165,7.61-.748,11.237-.251a43.525,43.525,0,0,1,5.517,1.426,21.025,21.025,0,0,0,5.931.586c1.958-.034,3.884-.118,5.812-.04s3.888.4,5.892.48a16.732,16.732,0,0,0,6.005-.845,50.219,50.219,0,0,0,5.421-2.386,13.815,13.815,0,0,1,5.249-1.5,22.432,22.432,0,0,1,5.505.6,57.343,57.343,0,0,0,5.776,1.106,13.979,13.979,0,0,0,6.077-.531,9.474,9.474,0,0,0,2.843-1.545,24.556,24.556,0,0,0,3.149-3.479c.142-.188.281-.373.419-.551.494-.64-.291-2.352-1.693-.673",
    transform: "translate(-18.864 -141.424)",
    fill: "#9b725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_770",
    "data-name": "Path 770",
    d: "M113.471,192.017l-.157.06a20.423,20.423,0,0,1-2.411.871,42.776,42.776,0,0,1-4.158,1.232,19.463,19.463,0,0,1-4.728-.046,69.816,69.816,0,0,0-8.505-.715,12.629,12.629,0,0,0-2.278.311,14.973,14.973,0,0,0-2.164.772,22.577,22.577,0,0,1-3.932,1.159c-1.3.311-2.522.507-3.74.867-.6.241-1.226.447-1.865.644a6.993,6.993,0,0,1-1.97.224,36.809,36.809,0,0,1-8.013-1.278c-1.346-.3-2.718-.538-4.109-.758-1.17-.2-7.838-3.244-8.865-2.73a1.131,1.131,0,0,0-.494.516,1.791,1.791,0,0,0,1.2,2.488c3.731.99,9.682,2.84,11.684,3.306a53.391,53.391,0,0,0,8.55.988c.366.005.732,0,1.1.026s.736.078,1.111.095a14.225,14.225,0,0,0,2.287.148,10.2,10.2,0,0,0,4.322-1.343c1.31-.715,2.5-1.549,3.738-2.217a7.993,7.993,0,0,1,1.726-.758,10.455,10.455,0,0,1,1.849-.34,21.964,21.964,0,0,1,4.01.1c1.365.12,2.748.315,4.153.489a31.4,31.4,0,0,0,4.332.272,10.446,10.446,0,0,0,1.129-.072,6.964,6.964,0,0,0,1.142-.179c.594-.131,1.123-.375,1.707-.55,1.047-.314,2.137-.407,3.192-.686a15.158,15.158,0,0,0,3.382-1.307c.77-.42,2.268-1.2,2.4-2.275a1.045,1.045,0,0,0-.6-1.1c-.989-.41-2.239.47-3.059.983a10.386,10.386,0,0,1-1.963.807",
    transform: "translate(-36.528 -124.228)",
    fill: "#9b725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_771",
    "data-name": "Path 771",
    d: "M133.112,438a24.261,24.261,0,1,1-24.261-24.261A24.261,24.261,0,0,1,133.112,438",
    transform: "translate(-55.273 -270.344)",
    fill: "#00653b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    d: "M108.138,269.079,90.422,417.025H35.349L17.632,269.079Zm3.515-3.119H14.117L32.309,417.869a2.574,2.574,0,0,0,2.555,2.275H90.906a2.574,2.574,0,0,0,2.555-2.275Z",
    transform: "translate(-9.224 -173.783)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_123",
    "data-name": "Rectangle 123",
    width: 103.055,
    height: 3.119,
    transform: "translate(1.846 90.552)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_300",
    "data-name": "Group 300",
    transform: "translate(4.893 92.177)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_299",
    "data-name": "Group 299"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_298",
    "data-name": "Group 298",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    d: "M111.652,265.959,93.463,417.869a2.572,2.572,0,0,1-2.558,2.274H51.132L96.274,279.316l-81.446-6.585-.71-6.772Z",
    transform: "translate(-14.117 -265.959)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    d: "M106.8,262.832H0l.732-5.516H106.073Z",
    transform: "translate(0 -168.135)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    d: "M78.934,132.542a44.778,44.778,0,0,1,30.436,42.31h-95.1A44.778,44.778,0,0,1,44.7,132.542Zm.23-1.386H44.475l-.217.074a46.152,46.152,0,0,0-31.375,43.622v1.386h97.873v-1.386A46.152,46.152,0,0,0,79.381,131.23Z",
    transform: "translate(-8.418 -85.7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_303",
    "data-name": "Group 303",
    transform: "translate(0 89.181)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_302",
    "data-name": "Group 302"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_301",
    "data-name": "Group 301",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    d: "M106.8,262.832H0l.732-5.516H106.073Z",
    transform: "translate(0 -257.317)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_306",
    "data-name": "Group 306",
    transform: "translate(66.334 46.844)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_305",
    "data-name": "Group 305"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_304",
    "data-name": "Group 304",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M203.534,177.466A44.071,44.071,0,0,0,191.4,135.159h4.18a44.773,44.773,0,0,1,30.437,42.307Z",
    transform: "translate(-191.397 -135.159)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    d: "M54.546,257.319v1.04H1.707l.125-.936.014-.1Z",
    transform: "translate(-1.115 -168.137)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    "data-name": "Path 779",
    d: "M168.421,217.543c.117.365-.358.843-1.061,1.069s-1.368.113-1.485-.251.358-.843,1.061-1.069,1.368-.114,1.485.251",
    transform: "translate(-108.375 -141.906)",
    fill: "#9b725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    "data-name": "Path 780",
    d: "M144.97,195.863c-.069.191-.422.238-.79.107s-.61-.392-.542-.583.421-.238.789-.107.611.393.543.583",
    transform: "translate(-93.849 -127.55)",
    fill: "#9b725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    d: "M184.421,185.543c.117.365-.358.843-1.061,1.069s-1.368.113-1.485-.251.358-.843,1.061-1.069,1.368-.114,1.485.251",
    transform: "translate(-118.83 -120.997)",
    fill: "#9b725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    d: "M109.96,197.413c.063.2-.192.451-.568.572s-.733.061-.8-.134.192-.451.568-.572.732-.061.8.134",
    transform: "translate(-70.953 -128.864)",
    fill: "#9b725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    "data-name": "Path 783",
    d: "M215.96,212.413c.063.2-.192.451-.568.572s-.733.061-.8-.134.192-.451.568-.572.732-.061.8.134",
    transform: "translate(-140.216 -138.666)",
    fill: "#9b725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    d: "M47.96,248.413c.063.2-.192.451-.568.572s-.733.061-.8-.134.192-.451.568-.572.732-.061.8.135",
    transform: "translate(-30.441 -162.189)",
    fill: "#9b725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    "data-name": "Path 785",
    d: "M95.031,225.912c-.094.163-.425.148-.739-.033s-.492-.46-.4-.623.425-.148.739.034.492.46.4.623",
    transform: "translate(-61.336 -147.112)",
    fill: "#9b725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    "data-name": "Path 786",
    d: "M210.031,245.912c-.094.163-.425.148-.739-.033s-.493-.46-.4-.623.425-.148.739.034.492.46.4.623",
    transform: "translate(-136.479 -160.18)",
    fill: "#9b725e"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5_copy_3",
    "data-name": "Rectangle 5 copy 3",
    d: "M1039.958,376.119l-59.37-20.646c-4.672-1.625-9.964,1.356-12.041,6.686-2.118,5.437-.236,11.6,4.434,13.758l60.033,27.728c8.292,3.83,16.938.269,18.776-7.964C1053.578,387.676,1048.058,378.935,1039.958,376.119Z",
    transform: "translate(-637.491 -64.849) rotate(-9)",
    fill: "#db8e6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5_copy_3-2",
    "data-name": "Rectangle 5 copy 3",
    d: "M1027.313,535.435l-59.37-20.646c-4.672-1.625-9.964,1.356-12.041,6.686-2.118,5.437-.236,11.6,4.434,13.758l60.033,27.728c8.292,3.83,16.938.269,18.777-7.964C1040.934,546.993,1035.414,538.252,1027.313,535.435Z",
    transform: "translate(-644.29 -151.965) rotate(-9)",
    fill: "#db8e6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5_copy_3-3",
    "data-name": "Rectangle 5 copy 3",
    d: "M1039.66,465.328l-59.37-20.646c-4.672-1.625-9.964,1.356-12.041,6.686-2.118,5.437-.236,11.6,4.434,13.758l60.033,27.728c8.292,3.83,16.938.269,18.776-7.964C1053.28,476.885,1047.76,468.145,1039.66,465.328Z",
    transform: "translate(-644.961 -113.05) rotate(-9)",
    fill: "#db8e6c"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstContent);
export default __webpack_public_path__ + "static/media/first-content.e33f1febce57fc8d80082575eb7bb49c.svg";
export { ForwardRef as ReactComponent };